import { render, staticRenderFns } from "./RoutesContainer.vue?vue&type=template&id=79ab25ee&scoped=true&"
import script from "./RoutesContainer.vue?vue&type=script&lang=js&"
export * from "./RoutesContainer.vue?vue&type=script&lang=js&"
import style0 from "./RoutesContainer.vue?vue&type=style&index=0&id=79ab25ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab25ee",
  null
  
)

export default component.exports